
import Footer from './components/Footer/Footer';
import './App.css';
import Home from './Pages/Home';
import Header from "./components/Header/Header"

function App() {
  return (
    <>
      <Header />
      <Home />
      <Footer />
    </>
  );
}

export default App;
